module.exports = __webpack_public_path__ + "img/1-15.62a83fdc.png";